(function($) {
    //editor ready
    RVwys.plugin['socialWidget'] = true;

    $(document).bind('editorReady', function() {
        // Set a cmdhref
        /* $('.wys-rowFooterSocial .wbInputbox').keyup(function(e){
			var isCmd = $(this).attr('cmd-is');
			var valSocail = $(this).val();
			var oThis = valSocail;

			console.log($(this).is('[cmd-is]'));
			
			if ($(this).is('[cmd-is]')) {
				
				if(isCmd != 'line'){
					if(!valSocail.match(/(^\#)|(http|https)/)){
						oThis = (valSocail == '')? valSocail : 'https://'+valSocail;
					}
				}
				
				$(this).val(oThis);
	
				if(isCmd == 'line'){
					if(!valSocail.match(/(^\#)|(http|https)/)){
						oThis = (valSocail == '')? valSocail : 'https://line.me/ti/p/~'+valSocail;
					}
				}
			}

			var fb = parent.$('#frameBody').get(0).contentWindow;
			fb.$('.link-footer.link-footer-'+isCmd).attr('cmdhref', oThis);

		}); 
		 */
    });

    //widget ready
    $(document).bind('designReady', function(e) {
        $('#socialbutton a').click(function(e) {
            var oThis = $(this);
            if ($(this).is('a')) {
                oThis = $(this).closest('#socialbutton');
            }

            RVwys.widget.ovewEvent(oThis);
        });

        parent.$('.btn-apply-social').click(function() {
            var datasetting = {};
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var id = parent.elmSetWidget.get(0).id;

            fb.$('#' + id).each(function() {
                $.each(this.attributes, function() {
                    if (this.specified) {
                        if (this.name.match(/setting_/g)) {
                            datasetting[this.name] = this.value;
                        }
                    }
                });
            });

            $.ajax({
                type: 'GET',
                url: '/admin/core/widget/applysocialbutton',
                data: {
                    setting: datasetting,
                    _token: $('meta[name="csrf-token"]').attr('content')
                },
                success: function(data) {
                    var othisNew = $(data);
                    //					parent.$('.wys-rowFooterSocial').hide();

                    othisNew.find('a').click(function(e) {
                        if ($(this).attr('nowidget') != undefined) return false;

                        if (
                            $(this)
                                .parent()
                                .parent()
                                .hasClass('pagination')
                        )
                            return false;
                        $('.linkToolEditable').show();
                        $('.linkToolEditable')
                            .find('.linkToEdit')
                            .hide()
                            .end()
                            .find('.linkToRemove')
                            .hide();

                        var h = $(this).attr('href') || '';

                        h = h.replace(
                            parent.wex.url.baseUrl,
                            parent.wex.url.WYS_SHOW_URL
                        );
                        var oLinkk = $(
                            '<a href="' +
                                h +
                                '"> <i class="uk-icon-external-link"></i>  ' +
                                h +
                                '</a>'
                        );
                        if (!h.match(/^\#/)) {
                            oLinkk.attr('target', '_blank');
                        }
                        $('.linkTo').html(oLinkk);
                        $('.linkToolEditable').css({
                            left: $(this).offset().left,
                            top: $(this).offset().top
                        });
                        return false;
                    });

                    $(
                        '[widgetname=social_widget] .containerWidget'
                    ).replaceWith(othisNew);

                    parent.console.pop.success({
                        text: rvLang('Apply Social Setting Global'),
                        delay: 5000
                    });
                },
                error: function(jqXHR, exception) {
                    $('.overlaypanel').remove();
                }
            });
        });
    });
})(jQuery);
